export default "__VITE_ASSET__DfKQCdc6__"